import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { useParams } from "react-router-dom";
import { ChatForumComp, ListDocumentForumComp } from "../";
import { MySwal } from "../../../library/swal";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import {
  IconArrowLeft,
  IconZoomIn,
  IconBrandTelegram,
} from "@tabler/icons-react";
import { LoadingAtom } from "../../atoms";
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const ListForumComp = () => {
  const routeParams = useParams();

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const [isForumExist, setIsForumExist] = useState("");
  const [showDocument, setshowDocument] = useState(false);
  const [loadingForum, setLoadingForum] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [elementSelected, setElementSelected] = useState("");
  const [abjadSelected, setAbjadSelected] = useState("");
  const [namaLengkap, setNamaLengkap] = useState("");
  const [text, setText] = useState("");
  const [idForum, setIdForum] = useState("");
  const [idBab, setidBab] = useState("");
  const [chapters, setChapters] = useState([]);
  const [forums, setForums] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [newMsg, setNewMsg] = useState([]);

  const fetchChapters = async () => {
    // console.log(routeParams.idMasterAkreditasi)
    try {
      const options = {
        url: `/chapters/getListByFk/${routeParams.idMasterAkreditasi}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false
      setChapters(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleChangeChapter = (value) => {
    setLoadingForum(true);
    setIdForum("");
    setidBab(value);
    fetchForums(value);
  };

  useEffect(() => {
    validateAccreditation()
  }, []);

  const validateAccreditation = () => {

    const requestBody = {
      id: routeParams.id,
      idMasterAkreditasi: routeParams.idMasterAkreditasi
    };

    axios({
      url: "/accreditations/validate",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res.status)
        // return false
        if (res.status === 200) {
          fetchChapters();
          fetchUser();
        } else {
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: `${res?.message}`,
          });
        }
      })
      .catch((err) => {
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  const fetchUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data?.data?.namaLengkap)
      // return false
      setNamaLengkap(data?.data?.namaLengkap);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchForums = async (idBab) => {
    // console.log(routeParams.idMasterAkreditasi)
    try {
      const options = {
        url: `/forum/find-two-params/${routeParams.id}/${idBab}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.length)
      // return false
      setLoadingForum(false);
      if (data.length === 0) {
        setIsForumExist(false);
        return false;
      }
      setIsForumExist(true);
      setForums(data);

      if (idForum !== "") {
        handleAfterSubmitChat();
      }
    } catch (err) {
      console.log(err.message);
      setLoadingForum(false);
    }
  };

  const handleSubmitChat = (idForum) => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      idForum: idForum,
      text: text,
    };
    // console.log(requestBody)
    // return false
    axios({
      url: "/forum-chat/create-chat",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        setText("");
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Success",
            text: "Berhasil menambahkan diskusi!",
          });

          setLoading(false);
          setDisabled(false);

          fetchForums(idBab);
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  const handleClickDocument = (element, abjad, documents) => {
    if (documents.length === 0) {
      MySwal.fire({
        icon: "info",
        title: "Informasi",
        text: "Belum ada dokumen terupload!",
      });
      return false;
    }
    setElementSelected(element);
    setAbjadSelected(abjad);
    setDocuments(documents);
    setshowDocument(true);
  };

  const handleClickAccordionItem = (idForum, chats) => {
    setIdForum(idForum);
    // console.log(namaLengkap)
    setNewMsg([]);
    chats.map((chat) =>
      chat?.createdBy === namaLengkap
        ? setNewMsg((newMsg) => [
          ...newMsg,
          {
            id: chat?.id,
            idForum: chat?.idForum,
            text: chat?.text,
            createdBy: chat?.createdBy,
            updatedBy: chat?.updatedBy,
            createdAt: chat?.createdAt,
            updatedAt: chat?.updatedAt,
            flagMsg: "own",
          },
        ])
        : setNewMsg((newMsg) => [
          ...newMsg,
          {
            id: chat?.id,
            idForum: chat?.idForum,
            text: chat?.text,
            createdBy: chat?.createdBy,
            updatedBy: chat?.updatedBy,
            createdAt: chat?.createdAt,
            updatedAt: chat?.updatedAt,
            flagMsg: "others",
          },
        ])
    );
  };

  // console.log(newMsg)

  const handleAfterSubmitChat = async () => {
    try {
      const options = {
        url: `/forum/find-chat-by-idforum/${idForum}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false
      setNewMsg([]);
      data.map((chat) =>
        chat?.createdBy === namaLengkap
          ? setNewMsg((newMsg) => [
            ...newMsg,
            {
              id: chat?.id,
              idForum: chat?.idForum,
              text: chat?.text,
              createdBy: chat?.createdBy,
              updatedBy: chat?.updatedBy,
              createdAt: chat?.createdAt,
              updatedAt: chat?.updatedAt,
              flagMsg: "own",
            },
          ])
          : setNewMsg((newMsg) => [
            ...newMsg,
            {
              id: chat?.id,
              idForum: chat?.idForum,
              text: chat?.text,
              createdBy: chat?.createdBy,
              updatedBy: chat?.updatedBy,
              createdAt: chat?.createdAt,
              updatedAt: chat?.updatedAt,
              flagMsg: "others",
            },
          ])
      );
    } catch (err) {
      // console.log(err.message)
      MySwal.fire({
        icon: "error",
        title: "Oops, Error!",
        text: `${err?.response?.data?.message}`,
      });
    }
  };

  // console.log(idForum)

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="row col-12 mb-5">
            <div className="col-lg-5 col-12">
              <select
                className="form-select"
                onChange={(e) => handleChangeChapter(e.target.value)}
                value={idBab}
              >
                <option value="">- Pilih -</option>
                {chapters.map((chapter) => (
                  <option value={chapter.id}>
                    {chapter.Deskripsi} ({chapter.Singkatan})
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-7 col-12" style={{ textAlign: "right" }}>
              <button
                onClick={() => handleChangePage("/accreditation")}
                className="btn btn-sm btn-info"
              >
                <IconArrowLeft stroke={2} /> Kembali
              </button>
            </div>
          </div>
          {isForumExist === true ? (
            loadingForum === false ? (
              <div className="row col-12 mb-3">
                {/*begin::Accordion*/}
                <div className="accordion" id="kt_accordion_1">
                  {forums.map((forum, index) => (
                    <div className="accordion-item" key={index}>
                      <h2
                        className="accordion-header"
                        id="kt_accordion_1_header_3"
                      >
                        <button
                          onClick={() =>
                            handleClickAccordionItem(forum?.id, forum?.chats)
                          }
                          className="accordion-button fs-4 fw-bold collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#kt_accordion_1_body_${index}`}
                          aria-expanded="false"
                          aria-controls={`#kt_accordion_1_body_${index}`}
                        >
                          {
                            forum?.skor?.variables_accreditation
                              ?.elements_accreditation?.Nomor
                          }
                          , EP: {forum?.skor?.variables_accreditation?.Abjad}
                        </button>
                      </h2>
                      <div
                        id={`kt_accordion_1_body_${index}`}
                        className="accordion-collapse collapse"
                        aria-labelledby="kt_accordion_1_header_3"
                        data-bs-parent="#kt_accordion_1"
                      >
                        <div className="accordion-body">
                          <div className="d-flex justify-content-between">
                            <strong>
                              {forum?.skor?.variables_accreditation?.Deskripsi}
                            </strong>
                            <button
                              className="btn btn-sm btn-success"
                              onClick={() =>
                                handleClickDocument(
                                  forum?.skor?.variables_accreditation
                                    ?.elements_accreditation?.Nomor,
                                  forum?.skor?.variables_accreditation?.Abjad,
                                  forum?.skor?.documents
                                )
                              }
                            >
                              <IconZoomIn stroke={2} /> Dokumen Pendukung
                            </button>
                          </div>
                          <hr className="mb-4"></hr>

                          <div className="row col-12">
                            {/*begin::Messenger*/}
                            <div className="card" id="kt_chat_messenger">
                              {/*begin::Card body*/}
                              <div
                                className="card-body"
                                id="kt_chat_messenger_body"
                              >
                                {/*begin::Messages*/}
                                <div
                                  className="scroll-y me-n5 pe-5 h-300px h-lg-auto"
                                  data-kt-element="messages"
                                  data-kt-scroll="true"
                                  data-kt-scroll-activate="{default: false, lg: true}"
                                  data-kt-scroll-max-height="auto"
                                  data-kt-scroll-dependencies="#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer"
                                  data-kt-scroll-wrappers="#kt_content, #kt_chat_messenger_body"
                                  data-kt-scroll-offset="-2px"
                                >
                                  <ChatForumComp chats={newMsg} />
                                </div>
                                {/*end::Messages*/}
                              </div>
                              {/*end::Card body*/}
                              {/*begin::Card footer*/}
                              <div
                                className="card-footer pt-4"
                                id="kt_chat_messenger_footer"
                              >
                                {/*begin::Input*/}
                                <textarea
                                  onChange={(e) => setText(e.target.value)}
                                  value={text}
                                  className="form-control form-control-flush mb-3"
                                  rows={1}
                                  data-kt-element="input"
                                  placeholder="Type a message"
                                />
                                {/*end::Input*/}
                                {/*begin:Toolbar*/}
                                <div className="d-flex flex-stack">
                                  {/*begin::Send*/}
                                  <button
                                    onClick={() => handleSubmitChat(forum?.id)}
                                    className="btn btn-light-primary"
                                    type="button"
                                    data-kt-element="send"
                                    disabled={disabled}
                                  >
                                    <IconBrandTelegram stroke={2} />{" "}
                                    {loading === true ? "Sending" : "Send"}
                                  </button>
                                  {/*end::Send*/}
                                </div>
                                {/*end::Toolbar*/}
                              </div>
                              {/*end::Card footer*/}
                            </div>
                            {/*end::Messenger*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/*end::Accordion*/}
              </div>
            ) : (
              <LoadingAtom />
            )
          ) : isForumExist === false ? (
            <span className="badge badge-danger">Belum ada Forum!</span>
          ) : (
            ""
          )}
        </div>
      </div>

      <Modal
        show={showDocument}
        onHide={() => setshowDocument(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Daftar Dokumen{" "}
            <span className="text-info">
              {elementSelected}, EP:{abjadSelected}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListDocumentForumComp documents={documents} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ListForumComp;
